import Vue from 'vue'
import Router from 'vue-router'
import ECADashBoard from './views/ECADashBoard'
import TwoDimDashBoard from './views/TwoDimDashBoard'
import OuterTotalisticDashBoard from './views/OuterTotalisticDashBoard'

Vue.use(Router)

export default new Router({
  base: '/ca',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'eca-dashboard',
      component: ECADashBoard
    },
    {
      path: '/2d',
      name: 'two-dim-dashboard',
      component: TwoDimDashBoard
    },
    {
      path: '/2d/outer-totalistic',
      name: 'outer-totailstic-dashboard',
      component: OuterTotalisticDashBoard
    }
  ]
})
